import { gql } from '@apollo/client'
import PropTypes from 'prop-types'

const externalPrimaryTicketShopFragment = gql`
  fragment externalPrimaryTicketShop on ExternalPrimaryTicketShop {
    id
    startDate
    state
    shopImageUrl {
      url
      trackingUrl
      path
      host
    }
    shopUrl {
      url
      trackingUrl
      path
      host
    }
  }
`

export const externalPrimaryTicketShopFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  state: PropTypes.oneOf(['CREATED', 'DISABLED', 'EXPIRED', 'ON_SALE', 'SOLD_OUT']).isRequired,
  shopImageUrl: PropTypes.shape({
    url: PropTypes.string.isRequired,
    trackingUrl: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    host: PropTypes.string,
  }),
  shopUrl: PropTypes.shape({
    url: PropTypes.string.isRequired,
    trackingUrl: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    host: PropTypes.string,
  }),
})

export default externalPrimaryTicketShopFragment
